export default __webpack_public_path__ + "9bf0965c7b5cdcf8208ea6ac61433e56.svg";